<header class="site-header">
  <div class="header-container">
    <!-- Logo -->
    <a routerLink="/" class="header-logo">
      <img src="assets/images/horseloop-logo.png" alt="HorseLoop" />
    </a>

    <!-- Mobile Toggle -->
    <button
      class="mobile-toggle"
      [class.active]="isMobileMenuOpen"
      type="button"
      (click)="toggleMobileMenu()"
      aria-label="Toggle navigation"
    >
      <span class="toggle-bar"></span>
      <span class="toggle-bar"></span>
      <span class="toggle-bar"></span>
    </button>

    <!-- Navigation -->
    <nav class="main-nav" [class.show]="isMobileMenuOpen" id="mainNav">
      <ul class="nav-links">
        <li><a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileMenu()">{{ 'header.nav.home' | translate }}</a></li>
        <li><a routerLink="/shows" routerLinkActive="active" (click)="closeMobileMenu()">{{ 'header.nav.competitions' | translate }}</a></li>
        <li><a routerLink="/clinics" routerLinkActive="active" (click)="closeMobileMenu()">{{ 'header.nav.trainings' | translate }}</a></li>
        <li><a routerLink="/trainers" routerLinkActive="active" (click)="closeMobileMenu()">{{ 'header.nav.trainers' | translate }}</a></li>
        <li><a routerLink="/organisations" routerLinkActive="active" (click)="closeMobileMenu()">{{ 'header.nav.organisations' | translate }}</a></li>
        <li><a routerLink="/stores-services" routerLinkActive="active" (click)="closeMobileMenu()">{{ 'header.nav.storesAndServices' | translate }}</a></li>
        <li><a routerLink="/about" routerLinkActive="active" (click)="closeMobileMenu()">{{ 'header.nav.about' | translate }}</a></li>
      </ul>

      <!-- Actions -->
      <div class="header-actions">
        <!-- Language selector -->
        <div class="language-selector dropdown">
          <button
            class="lang-btn"
            id="languageDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <span class="lang-flag">{{ getCurrentLanguage()?.flag }}</span>
            <span class="lang-code">{{ currentLang.toUpperCase() }}</span>
            <i class="fa fa-chevron-down chevron"></i>
          </button>
          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
            @for (lang of languages; track lang.code) {
              <li>
                <button
                  class="dropdown-item"
                  [class.active]="currentLang === lang.code"
                  (click)="changeLanguage(lang.code)"
                >
                  <span class="lang-flag">{{ lang.flag }}</span>
                  {{ lang.label }}
                </button>
              </li>
            }
          </ul>
        </div>

        <!-- Not logged in -->
        @if (!isAuthenticated) {
          <a routerLink="/auth/login" class="btn-login" (click)="closeMobileMenu()">
            {{ 'header.signIn' | translate }}
          </a>
        }

        <!-- Logged in -->
        @if (isAuthenticated) {
          <div class="user-section">
            <!-- Company selector -->
            @if (companies && companies.length > 0) {
              <div class="company-selector">
                <button
                  class="company-btn"
                  data-kt-menu-trigger="click"
                  data-kt-menu-attach="parent"
                  data-kt-menu-placement="bottom-end"
                >
                  <i class="fa fa-building"></i>
                  <span class="company-name">{{ storageService.getSelectedCompany()?.entity_name || 'Select' }}</span>
                  <i class="fa fa-chevron-down chevron"></i>
                </button>
                <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-semibold py-4 fs-6 w-225px" data-kt-menu="true">
                  <app-header-company-select [companies]="companies" />
                </div>
              </div>
            }

            <!-- Chat dropdown -->
            <app-chat-dropdown></app-chat-dropdown>

            <!-- Profile dropdown -->
            <div class="profile-dropdown dropdown">
              <button
                class="profile-btn"
                id="profileDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                @if (userObj?.profile_image_url) {
                  <img
                    [src]="userObj.profile_image_url"
                    alt="Profile"
                    class="profile-avatar"
                  />
                } @else {
                  <div class="profile-avatar-placeholder">
                    <i class="fa fa-user"></i>
                  </div>
                }
                <span class="profile-name">{{ userObj?.first_name || 'Profile' }}</span>
                <i class="fa fa-chevron-down chevron"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="profileDropdown">
                <li class="dropdown-header">{{ 'header.myAccount' | translate }}</li>
                <li><a class="dropdown-item" routerLink="/user-profile" (click)="closeMobileMenu()">
                  <i class="fa fa-user"></i> {{ 'header.profile' | translate }}
                </a></li>
                @if (superAdmin) {
                  <li><a class="dropdown-item" routerLink="/admin" (click)="closeMobileMenu()">
                    <i class="fa fa-shield-alt"></i> {{ 'header.admin' | translate }}
                  </a></li>
                }
                <li><hr class="dropdown-divider"></li>
                <li>
                  <button class="dropdown-item logout-item" (click)="onSignOut(); closeMobileMenu()">
                    <i class="fa fa-sign-out-alt"></i> {{ 'header.signOut' | translate }}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        }
      </div>
    </nav>
  </div>
</header>
